export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">51</span>
              <span className="text-heading text-xl text-background-50">51漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              51漫画网 — 海量漫画在线免费阅读平台。支持51漫画在线观看和51漫画免费看，高清画质、下拉式阅读、每日更新，无需下载即可畅读全本漫画。热血、恋爱、玄幻、悬疑等多元题材，尽在51漫画在线。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <div className="space-y-2">
              {[
                { label: '人气排行榜', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '漫画索引', href: '#index' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="block text-sm text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">热门题材</h4>
            <div className="flex flex-wrap gap-2">
              {['热血冒险', '恋爱校园', '玄幻修仙', '悬疑推理', '科幻未来', '搞笑日常', '古风言情', '异能都市'].map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="px-3 py-1.5 bg-background-800 text-background-300 rounded-lg text-xs no-underline cursor-pointer hover:bg-background-700 transition-colors"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              更多合作伙伴信息即将公布，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 51漫画网 | 51漫画在线观看 · 51漫画免费看 · 51漫画在线看全集免费下拉式阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-background-300 no-underline cursor-pointer">回到顶部</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-500 hover:text-background-300 no-underline cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}